import { type BrandId, brands } from './brands'

const domainToBrand: Record<string, BrandId> = {
  'app.growinggenerations.com': 'gg',
  'app.circlesurrogacy.com': 'circle',
  'app.everie.com': 'everie',
}

function getBrandFromQueryParam(): BrandId | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const brandParam = params.get('brand')
  if (brandParam && brandParam in brands) {
    return brandParam as BrandId
  }
  return null
}

function getBrandFromHostname(): BrandId {
  if (typeof window === 'undefined') return 'gg'
  const hostname = window.location.hostname
  return domainToBrand[hostname] ?? 'gg'
}

export function resolveBrand(): BrandId {
  const queryBrand = getBrandFromQueryParam()
  if (queryBrand) return queryBrand

  return getBrandFromHostname()
}
